import { usePlanStatus } from "@/react/hooks/usePlanStatus";

import { UPGRADE_PATHS } from "../constants";
import { CANCEL_SCHEDULED_DOWNGRADE_SOURCES } from "../types";
import type { CancelScheduledDowngradeModalSource } from "../types";
import { useUpgradePlanContext } from "../UpgradePlanContext";
import { useBlockPlanTrialDowngrade } from "./useBlockPlanTrialDowngrade";
import { useCancelDowngradeScheduledHandler } from "./useCancelDowngradeScheduledHandler";

export const useUpgradeInitialPath = (): string => {
  const {
    plan,
    showPlanDetails: shouldShowPlanDetails,
    source,
    shouldSkipProrationStep,
    isRenewal,
  } = useUpgradePlanContext();

  const { shouldShowProration } = usePlanStatus();
  const { shouldBlockPlanTrialDowngrade } = useBlockPlanTrialDowngrade();
  const { isScheduledDowngradeActive } = useCancelDowngradeScheduledHandler({
    source: (source ||
      CANCEL_SCHEDULED_DOWNGRADE_SOURCES.PLAN_DETAILS) as CancelScheduledDowngradeModalSource,
  });

  const shouldShowProrationDetails = Boolean(
    shouldShowProration(plan) && !shouldSkipProrationStep,
  );

  switch (true) {
    case isRenewal:
      return UPGRADE_PATHS.RENEWAL;
    case isScheduledDowngradeActive:
      return UPGRADE_PATHS.CANCEL_SCHEDULED_DOWNGRADE_MODAL;
    case shouldBlockPlanTrialDowngrade:
      return UPGRADE_PATHS.BLOCK_PLAN_TRIAL_DOWNGRADE;
    case shouldShowPlanDetails:
      return UPGRADE_PATHS.PLAN_DETAILS;
    case shouldShowProrationDetails:
      return UPGRADE_PATHS.PRORATION;
    default:
      return UPGRADE_PATHS.LOADING;
  }
};
